import { Component, EventEmitter, Input, Output, NgModule, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';

import { TrackingnumberRoutingModule } from './trackingnumber.routing.module';

@Component({
  selector: 'trackingnumber',
  template: `
  <h3 class="text-center blue-text"><i class="fa fa-location-arrow fa-4x"></i> Tracking</h3>
  <div class="md-form">
    <input type="text" id="form2" class="form-control" [(ngModel)]="trackingNumber">
    <label for="form2">Enter your tracking number</label>
  </div>
  <div class="text-center">
    <button [disabled]="!trackingNumber" class="btn btn-success" (click)="track()">
        <i *ngIf="loading" class="fa fa-spinner fa-spin"> </i>
        <span *ngIf="!loading">Track</span>
    </button>
  </div>
  <div *ngIf="error" class="text-center">
    <span class="help-block text-danger" style="font-size: 15px">
        <b>{{ error }}</b>
    </span>
  </div>`
})

export class TrackingnumberComponent {
  public trackingNumber: string = '';
  public error: string = '';
  public loading: boolean = false;

  constructor(public itemService: GenericdatasetService,
    public router: Router) {
  }

  track() {
    this.error = '';
    this.loading = true;
    setTimeout(() => {
      if (this.trackingNumber) {
        this.itemService.setrestName('filetransports');
        this.itemService.getItems(1, 0, [{ fieldName: 'trackingnumber', value: this.trackingNumber }], [
          { name: 'counter', fieldName: 'counter', caption: 'counter', orderBy: 1, orderByCode: '+', datatype: 0, include: null }
        ], '')
          .subscribe(
          (item) => {
            if (item.length == 1) {
              this.router.navigate(['/', 'filetransports', item[0].id]);
            } else {
              this.error = this.trackingNumber + ' not found';
            }
          }, (error) => {
          }, () => {
            this.loading = false;
          });
      }
    }
      , 3000);
  }
}
